import BaseApi from "./BaseApi";

export default class CargoService {

    static async OnGetListaCodigoDescricao() {
        try {
            let res = await BaseApi.get(`/v1/Cargo/ListaCodigoDescricao`);
            return res.data;

        } catch (error) {
            return error.response.data;
        }
    }
}